<template>
    <div class="container-fluid">

          <!-- Page Heading -->
          <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Settings</h1>
          </div>

          <!-- Content Row -->
          <div class="row">
              <div class="col-12">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a @click.prevent="tab='user'" :class="['nav-link', tab == 'user' ? 'active' : '']" id="user-tab" data-toggle="tab" href="#user" role="tab" aria-controls="user" aria-selected="false">User</a>
                    </li>
                    <li class="nav-item">
                        <a @click.prevent="tab='system'" :class="['nav-link', tab == 'system' ? 'active' : '']" id="system-tab" data-toggle="tab" href="#system" role="tab" aria-controls="system" aria-selected="true">System</a>
                    </li>
                </ul>
                <div class="tab-content">
                    <user-settings :active="tab == 'user'" />
                    <system-settings :active="tab == 'system'" />
                </div>
              </div>
          </div>

        </div>
        <!-- /.container-fluid -->
</template>

<script>
import UserSettings from '@/components/UserSettings';
import SystemSettings from '@/components/SystemSettings';

export default {
    name: 'Settings',
    data: () => ({
        tab: 'user',
    }),
    components: {
        'user-settings': UserSettings,
        'system-settings': SystemSettings
    }
}
</script>